import React, { useEffect, useState } from 'react';
import { Form, Input, Select } from 'antd';

const { Option } = Select;

const CArticuloElectrodomesticoEmpresa = () => {
  const [auxiliares, setAuxiliares] = useState({
    eficiencias: [],
    capacidades: [],
    voltajes: []
  });

  useEffect(() => {
    const fetchAuxiliares = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/electrodomestico/auxiliares`);
        const data = await res.json();
        setAuxiliares(data);
      } catch (error) {
        console.error('Error al cargar auxiliares:', error);
      }
    };

    fetchAuxiliares();
  }, []);

  return (
    <>
      <Form.Item name="consumo_energia" label="Consumo de Energía">
        <Input />
      </Form.Item>

      <Form.Item name="eficiencia_energetica" label="Eficiencia Energética">
        <Select placeholder="Seleccione una opción">
          {auxiliares.eficiencias.map(e => (
            <Option key={e.efe_id} value={e.efe_nombre}>{e.efe_nombre}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="capacidad" label="Capacidad">
        <Input />
      </Form.Item>

      <Form.Item name="unidad_capacidad" label="Unidad de Capacidad">
        <Select placeholder="Seleccione una unidad">
          {auxiliares.capacidades.map(c => (
            <Option key={c.cap_id} value={c.cap_nombre}>{c.cap_nombre}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="voltaje" label="Voltaje">
        <Select placeholder="Seleccione un voltaje">
          {auxiliares.voltajes.map(v => (
            <Option key={v.vol_id} value={v.vol_valor}>{v.vol_valor}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="dimensiones" label="Dimensiones">
        <Input />
      </Form.Item>
    </>
  );
};

export default CArticuloElectrodomesticoEmpresa;